import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { BaseService } from 'src/app/core/services/base.service';

@Injectable({
    providedIn: 'root',
})
export class SharedLatestNewsService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    /**
     * getLatestNews() - Buscar últimas notícias
     * @param departmentType : Tipo de Departamento
     */
    getLatestNews(departmentType, page, limit): Observable<any> {
        //console.log('getLatestNews');

        // Instancia do body através de BaseService.setBody();
        let body = this.setBody();
        // limit: Definir o retorno máximo de últimas notícias
        // body.set('limit', limit);
        body.set('page', page);
        body.set('limit', limit);
        // session_type: Definir retorno somente de últimas notícias
        body.set('sessionType', '1');
        // Inicializar o id do departamento selecionado
        body.set('departmentType', departmentType);

        let response = this.http
            .post(this.urlService + this.routeAdress.route_news, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }
}
